module.exports = __webpack_public_path__ + "img/mic-icon.0ce39f0d.svg";